import React from 'react';
import { Helmet } from 'react-helmet';

function StructuredData() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Amazon FBA Removal Order Fee Calculator",
    "description": "Calculate Amazon FBA removal order fees instantly. Get accurate estimates for disposal and return fees based on product dimensions, weight, and quantity.",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "All",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": [
      "Calculate Amazon FBA removal order fees",
      "Lookup product details using ASIN",
      "Save calculation history",
      "Accurate fee estimates based on Amazon's rate card"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}

export default StructuredData; 